import { useState, useCallback } from "react";
import { increaseSubStructure, increaseStructure } from "../apiHandles/user_progress";

const subIds = {
    6: "Directed",
    7: "Undirected",
    3: "Binary Tree",
    4: "AVL Tree",
    5: "Heap",
    9: "Singly Linked List",
    10: "Doubly Linked List",
    11: "1D Array",
    12: "2D Array",
    15: "Array-based Stack",
    16: "Linked List Stack",
    17: "Circular Queue",
    18: "Priority Queue",
    19: "Chaining",
    20: "Open Addressing",
    21: "Hash Set",
    22: "Tree Set",
    24: "Dynamic Array",
};

const dataPercentage = {
    "Directed": [12.5, 7.1],
    "Undirected": [16.6, 7.1],
    "Binary Tree": [12.5, 4.1],
    "AVL Tree": [12.5, 4.1],
    "Heap": [12.5, 4.1],
    "Singly Linked List": [12.5, 6.25],
    "Doubly Linked List": [12.5, 6.25],
    "1D Array": [12.5, 4.1],
    "2D Array": [10, 4.1],
    "Dynamic Array": [16.6, 4.1],
    "Chaining": [12.5, 7.1],
    "Open Addresing": [16.6, 7.1]
};

export const useFinishedGame = () => {
    const [isProcessing, setIsProcessing] = useState(false);

    const handleGameComplete = useCallback(async () => {
        if (isProcessing) return;

        setIsProcessing(true);

        try {
            const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));

            if (!selectedStage?.id) {
                console.error("No stage selected");
                return;
            }

            const gameFirstTry = localStorage.getItem('gameFirstTry');

            if (gameFirstTry !== "true") {
                return;
            }

            // Μόνο structure/substructure updates - XP handled στο GameWonModal
            const subStructureId = selectedStage.parent_sub_structure;
            const subStructure = subIds[subStructureId];
            const values = dataPercentage[subStructure];

            if (values && Array.isArray(values) && values.length >= 2) {
                const precSubStructure = values[0];
                const precStructure = values[1];

                increaseSubStructure(precSubStructure, selectedStage.id);
                increaseStructure(precStructure, selectedStage.id, selectedStage.parent_sub_structure);
            } else {
                console.warn(`No data percentage found for subStructure: ${subStructure}`);
            }

        } catch (error) {
            console.error("Error processing game completion:", error);
        } finally {
            setIsProcessing(false);
        }
    }, [isProcessing]);

    return { handleGameComplete, isProcessing };
};
